class VideoCustomElement extends HTMLElement {
    constructor() {
        super();
        this.button = this.querySelector('.pdp-info-section__custom-video-play-button');
        this.video = this.querySelector('video');
        this.videoPoster = this.querySelector('.pdp-info-section__custom-video-poster');
        this.videoElement = null;
        this.isLoaded = false;
        this.isPlaying = false;
    }

    connectedCallback() {
        console.log('VideoSnippet connected', this);
        this.initVideo();
    }

    initVideo() {
        if (this.button && this.video) {
            this.video.addEventListener('click', () => {
                if (this.isPlaying) {
                    this.pauseVideo();
                } else {
                    this.playVideo();
                }
            });

            this.button.addEventListener('click', (event) => {
                this.playVideo();
            });

            this.video.addEventListener('ended', () => {
                this.resetVideo();
                this.isPlaying = false;
            });

            this.video.addEventListener('pause', () => {
                this.showPoster();
                this.isPlaying = false;
            });
        }
    }

    playVideo() {
        this.hidePoster();
        this.video.play();
        this.isPlaying = true;
    }

    hidePoster() {
        if (this.button) this.button.style.display = 'none';
        if (this.videoPoster) this.videoPoster.style.display = 'none';
    }

    showPoster() {
        if (this.button) this.button.style.display = 'block';
        if (this.videoPoster) this.videoPoster.style.display = 'block';
    }

    resetVideo() {
        this.video.currentTime = 0;
        this.showPoster();
    }

    pauseVideo() {
        this.video.pause();
        this.showPoster();
    }
}

// Регистрируем элемент только один раз
if (!customElements.get('video-custom-element')) {
    customElements.define('video-custom-element', VideoCustomElement);
}